import Vue from "vue";
import Router from "vue-router";
import { Auth } from "aws-amplify";
import store from "./store";
import Setting from "@/views/Setting.vue";
import BaseScreen from "@/views/BaseScreen.vue";
import Login from "@/views/Login.vue";
import Dashboard from "@/views/Dashboard.vue";
import ReportManagement from "@/views/ReportManagement.vue";
import ForgetPassword from "@/views/ForgetPassword.vue";
import UserSetting from "@/views/UserSetting.vue";
import UsageHistory from "@/views/UsageHistory.vue";
import UsageHistoryOfAmount from "@/views/UsageHistoryOfAmount.vue";
import ResetPassword from "@/views/ResetPassword.vue";
import VerifyMTACode from "@/views/VerifyMTACode.vue";
import Contracts from "@/views/Contracts.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/forgot-password",
      name: "forgotPassword",
      component: ForgetPassword,
    },
    {
      path: "/new-password",
      name: "newPassword",
      component: ResetPassword,
    },
    {
      path: "/verify-code",
      name: "verifyCode",
      component: VerifyMTACode,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/",
      redirect: "/dashboard",
      component: BaseScreen,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "dashboard",
          name: "ダッシュボード",
          component: Dashboard,
        },
        {
          path: "/reports/:group_id",
          name: "レポート",
          component: ReportManagement,
        },
        {
          path: "/setting",
          name: "setting",
          component: Setting,
        },
        {
          path: "/userSetting",
          name: "ユーザ設定",
          component: UserSetting,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/contract",
          name: "契約情報",
          component: Contracts,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/usageHistory",
          name: "利用履歴",
          component: UsageHistory,
        },
        {
          path: "/usageHistoryOfAmount",
          name: "使用量",
          component: UsageHistoryOfAmount,
        },
        /*
        {
          path: '/reports',
          name: 'traffice',
          component: ReportMain,
          children: [
            {
              path: '',
              name: 'list',
              component: ReportList,
            },
            {
              path: ':id',
              name: 'detail',
              component: ReportDetail,
              props: true,
            },
          ],
        },
        */
      ],
    },
  ],
});

router.beforeEach( async (to, from, next) => {
  const isRequiredAuth = to.matched.some((record) => record.meta.requiresAuth);

  console.log(isRequiredAuth);
  console.log(to.fullPath);
  if (isRequiredAuth) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      store.dispatch("auth/alreadySignedIn", user);
      next();
    } catch (err) {
      console.log(err);
      next({ path: "/login", query: { redirect: to.fullPath }});
    }
  } else {
    next();
  }
});

export default router;
